<template>
    <div class="risk-details modal" @click="outsideClick()">
        <div class="modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <div class="content">
                    <span class="title-mobile">{{risk.risk.name}}  - <span :class="getRiskColor(risk.risk.label)">{{risk.risk.label}}</span></span>
                    <div class="column">
                        <div class="risks">
                            <span class="title">{{risk.risk.name}} - <span :class="getRiskColor(risk.risk.label)">{{risk.risk.label}}</span></span>
                            <template v-if="risk.altTitle == 'psicologico'">
                                <div class="text">
                                    <template v-if="risk.risk.label == 'Baixo'">
                                        De acordo com suas respostas destacamos que você está no caminho certo para evitar o adoecimento mental,
                                        isso porque, neste momento, você apresenta um perfil com baixa tendência para desenvolvimento de transtornos psicológicos,
                                        tais como depressão e ansiedade. Esta é uma boa notícia! Assim como a física, a saúde mental é uma parte integrante e complementar
                                        à manutenção das funções do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias
                                        que possibilitem o equilíbrio das funções mentais.
                                    </template>
                                    <template v-if="risk.risk.label == 'Médio'">
                                        De acordo com as respostas apresentadas observamos que é importante começar a refletir sobre a necessidade de conhecer melhor suas emoções,
                                        dedique um tempo para você, realize atividades prazerosas, cuide da sua alimentação e durma bem, evitando transtornos como depressão
                                        e ansiedade. Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas
                                        associados a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais
                                        do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o
                                        equilíbrio das funções mentais.
                                    </template>
                                    <template v-if="risk.risk.label == 'Alto'">
                                        De acordo com suas respostas destacamos que é importante prevenir o adoecimento mental, isso porque, neste momento,
                                        você apresenta um perfil com maior tendência para desenvolvimento de transtornos psicológicos, tais como depressão e ansiedade.
                                        Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas associados
                                        a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais do
                                        organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o
                                        equilíbrio das funções mentais. Para maiores informações sugerimos a realização de avaliação psicológica com um especialista.
                                    </template>
                                </div>
                            </template>
                            <template v-else-if="risk.altTitle == 'diagnostico_diabetes'">
                                <p>Diabetes é uma doença crônica na qual o corpo não produz insulina ou não consegue empregar adequadamente a 
                                insulina que produz. A insulina é o hormônio produzido pelo pâncreas para metabolizar a glicose e, assim, 
                                transformá-la em energia para o corpo.</p>

                                <p>A incapacidade de produzir insulina e a impossibilidade de usá-la de forma eficaz conduzem a níveis de glicose 
                                elevados no sangue: a hiperglicemia, caracterizando o diabetes.</p>

                                <p>Conforme orienta a Sociedade Brasileira de Diabetes, para a confirmação do diagnóstico desta patologia é necessário 
                                a repetição dos exames alterados em uma segunda amostra.</p>

                                <p>Ou seja, quando os valores de hemoglobina glicada são superiores a 6,5% é necessário repetir este exame para que seja 
                                confirmado ou não o diagnóstico de diabetes.</p>

                                <p>Quer saber mais?<br>
                                    <a href="https://diabetes.org.br/#diabetes" target="_blank">Home - Sociedade Brasileira de Diabetes</a>
                                </p>

                                <p>Fonte: Diretrizes da Sociedade Brasileira de Diabetes 2019-2020</p>
                            </template>
                            <template v-else-if="risk.altTitle == 'hipertensao'">
                                <span class="sub-title">Fatores Preponderantes - 
                                    <span class="sub-title-desc">São levados em consideração para o cálculo deste risco.</span>
                                </span>
                                <div class="risk-list">
                                    <div class="risk" v-for="(icon, x) in icons" v-bind:key="x">
                                        <div class="icon">
                                            <img :src="require(`@/assets/images/risks/${getIcon(icon.icon, icon.risk)}.png`)">
                                            <div v-if="imodifFac.includes(icon.title)" class="risk-info">
                                                <template>
                                                    <a-tooltip style="margin:0 5px;">
                                                        <template slot="title">
                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.
                                                        </template>
                                                        <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'exclamation-circle']"/>
                                                    </a-tooltip>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="detail">
                                            <span class="title">{{icon.title}}</span>
                                            <span class="info">{{icon.answer}}</span>
                                        </div>
                                    </div>
                                </div>
                                <span class="sub-title">Fatores Secundários - 
                                    <span class="sub-title-desc">Não são pontuados para o cálculo deste risco, mas podem influenciar na sua pressão arterial ao longo do tempo. 
                                    Fique de olho nos indicadores abaixo para evitar o desenvolvimento de Hipertensão.</span></span>
                                <div class="risk-list">
                                    <div class="risk" v-for="(icon, x) in iconsSec" v-bind:key="x">
                                        <div class="icon">
                                            <img :src="require(`@/assets/images/risks/${getIcon(icon.icon, icon.risk)}.png`)">
                                            <div v-if="imodifFac.includes(icon.title)" class="risk-info">
                                                <template>
                                                    <a-tooltip style="margin:0 5px;">
                                                        <template slot="title">
                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.
                                                        </template>
                                                        <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'exclamation-circle']"/>
                                                    </a-tooltip>
                                                </template>
                                            </div>
                                            <div v-else-if="icon.title == 'Hemoglobina Glicada (HbA1c)' && risk.altTitle == 'diabetes'" class="risk-info">
                                                <template>
                                                    <a-tooltip style="margin:0 5px;">
                                                        <template slot="title">
                                                            Este indicador é determinante para o risco de desenvolver diabetes. 
                                                        </template>
                                                        <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'exclamation-circle']"/>
                                                    </a-tooltip>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="detail">
                                            <span class="title">{{icon.title}}</span>
                                            <span class="info">{{icon.answer}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="risk-list">
                                    <div class="risk" v-for="(icon, x) in icons" v-bind:key="x">
                                        <div class="icon">
                                            <img :src="require(`@/assets/images/risks/${getIcon(icon.icon, icon.risk)}.png`)">
                                            <div v-if="imodifFac.includes(icon.title)" class="risk-info">
                                                <template>
                                                    <a-tooltip style="margin:0 5px;">
                                                        <template slot="title">
                                                            Esse é um fator de risco imodificável, porém influencia para o desenvolvimento desta doença.
                                                        </template>
                                                        <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'exclamation-circle']"/>
                                                    </a-tooltip>
                                                </template>
                                            </div>
                                            <div v-else-if="icon.title == 'Hemoglobina Glicada (HbA1c)' && risk.altTitle == 'diabetes'" class="risk-info">
                                                <template>
                                                    <a-tooltip style="margin:0 5px;">
                                                        <template slot="title">
                                                            Este indicador é determinante para o risco de desenvolver diabetes. 
                                                        </template>
                                                        <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'exclamation-circle']"/>
                                                    </a-tooltip>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="detail">
                                            <span class="title">{{icon.title}}</span>
                                            <span class="info">{{icon.answer}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="column" v-if="risk.altTitle != 'diagnostico_diabetes'">
                            <div class="row">
                                <div class="description">
                                    <div class="row column-reverse">
                                        <div class="column no-margin">
                                            <span class="title">{{risk.title}}</span>
                                            <detail-text :risk="risk.altTitle" />
                                        </div>
                                        <div class="column" v-if="risk.altTitle != 'psicologico' && risk.altTitle != 'diagnostico_diabetes'">
                                            <div class="legend-box">
                                                <span class="title">legenda</span>
                                                <div class="legends">
                                                    <div class="legend">
                                                        <div class="circle">
                                                            <img src="@/assets/images/risks/b_g.png">
                                                        </div>
                                                        <div class="legend-text">
                                                            Indicador de hábito ou condição foi pontuado de forma positiva. Procure manter assim. Parabéns!
                                                        </div>
                                                    </div>
                                                    <div class="legend">
                                                        <div class="circle">
                                                            <img src="@/assets/images/risks/b_y.png">
                                                            </div>
                                                        <div class="legend-text">
                                                            Indicador de hábito ou condição que merece atenção. Melhore ou controle-o bem!
                                                        </div>
                                                    </div>
                                                    <div class="legend">
                                                        <div class="circle">
                                                            <img src="@/assets/images/risks/b_r.png">
                                                        </div>
                                                        <div class="legend-text">
                                                            Indicador de hábito ou condição foi pontuado de forma negativa. 
                                                            Você precisa modificar este hábito ou manter controlada esta doença.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DetailText from './DetailText';

    export default {
        name: "kit-risks-details",
		components: { DetailText },
        props: {
            customer: Object,
            result: Object,
            risk: Object,
            answers: Array,
        },
        data() {
            return {
                user: {
                    age: null,
                    pressure_high: null,
                    pressure_low: null,
                    circunference: null,
                    gender: null,
                },
                icons: [],
                iconsSec: [],
                answersRisks: {
                    imc: {},
                    hdl: {},
                    ldl: {},
                    clt: {},
                    tri: {},
                    hba1c: {},
                    gli: {},
                    creatinine: {},
                    tfg: {},
                    smoke: {},
                    drink: {},
                    diabetes: {},
                    heartDisease: {},
                    selfHealth: {},
                    hospitalized: {},
                    medic: {},
                    caretaker: {},
                    limitedActivity: {},
                    dailyActivity: {},
                    dailyOth: {},
                    home: {},
                    walkSupport: {},
                    activity: {},
                    fruits: {},
                    animal: {},
                    diseases: {},
                    sleep: {},
                    pregnant: {},
                },
                imodifFac: ['Idade', 'Sexo biológico', 'Histórico Familiar Doença Crônica']
            }
        },
        methods: {
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            loadUser() {
                this.user.age = this.customer.age;
                this.user.pressure_high = this.answerSearch("Sistólica (alta):");
                this.user.pressure_low = this.answerSearch("Diastólica (baixa):");
                this.user.circunference = this.answerSearch("Circunferência abdominal (centímetros)");
                this.user.gender = this.customer.gender == 'M' ? 'Masculino' : 'Feminino';
            },
            loadRisks() {
                let imc = this.answerSearch("imc");
                imc = parseFloat(imc.weigth) / ( parseFloat(imc.heigth.replace(',', '.')) * parseFloat(imc.heigth.replace(',', '.')) );
                imc = imc.toString().substr(0, 4);

                this.answersRisks.imc.realValue = imc
                this.answersRisks.imc.value = imc + " kg/m²";
                if(imc <= 18.4) this.answersRisks.imc.risk = 'yellow';
                else if(imc >= 18.5 && imc <= 24.9) this.answersRisks.imc.risk = 'green';
                else this.answersRisks.imc.risk = 'red';

                if(!!this.result.hdl){
                    this.answersRisks.hdl.value = this.result.hdl + ' mg/dL';
                    if(this.customer.age > 20) this.answersRisks.hdl.risk = this.result.hdl > 40 ? 'green' : 'red';
                    else this.answersRisks.hdl.risk = this.result.hdl > 45 ? 'green' : 'red';
                }
                if(!!this.result.ldl){
                    this.answersRisks.ldl.value = this.result.ldl + ' mg/dL';
                    if(!!this.result.ldlAlt){
                        if(this.result.ldl < this.result.ldlAlt.range) this.answersRisks.ldl.risk = 'green';
                        else this.answersRisks.ldl.risk = 'red';
                    }else {
                        if(this.customer.age > 19)
                            if(this.result.ldl <= 129) this.answersRisks.ldl.risk = 'green';
                            else if(this.result.ldl > 129 && this.result.ldl <= 159) this.answersRisks.ldl.risk = 'yellow';
                            else if(this.result.ldl >= 160) this.answersRisks.ldl.risk = 'red';
                        else
                            if(this.result.ldl < 110) this.answersRisks.ldl.risk = 'green';
                            else if(this.result.ldl >= 110 && this.result.ldl <= 129) this.answersRisks.ldl.risk = 'yellow';
                            else if(this.result.ldl >= 130) this.answersRisks.ldl.risk = 'red';
                    }
                }
                if(!!this.result.colesterol_total){
                    this.answersRisks.clt.value = this.result.colesterol_total + ' mg/dL';
                    if (this.customer.age > 19) this.answersRisks.clt.risk = this.result.colesterol_total <= 129 ? 'green' : 'red';
                    else this.answersRisks.clt.risk = this.result.colesterol_total <= 110 ? 'green' : 'red';
                }
                if(!!this.result.triglicerideos){
                    this.answersRisks.tri.value = this.result.triglicerideos + ' mg/dL';
                    if(this.customer.age > 19) this.answersRisks.tri.risk = this.result.triglicerideos <= 129 ? 'green' : 'red';
                    else this.answersRisks.tri.risk = this.result.triglicerideos <= 110 ? 'green' : 'red';
                }
                if(!!this.result.hba1c){
                    this.answersRisks.hba1c.value = this.result.hba1c + ' %';
                    if(this.result.hba1c < 5.7 || this.result.glicose >= 70 && this.result.glicose <= 99) this.answersRisks.hba1c.risk = 'green';
                    else if(this.result.hba1c >= 5.7 && this.result.hba1c <= 6.4 || this.result.glicose < 70) this.answersRisks.hba1c.risk = 'yellow';
                    else this.answersRisks.hba1c.risk = 'red';
                }
                if(!!this.result.glicose){
                    this.answersRisks.gli.value = this.result.glicose + ' mg/dL';
                    if(this.result.glicose < 70) this.answersRisks.gli.risk = 'yellow';
                    else if(this.result.glicose >= 70 && this.result.glicose <= 99) this.answersRisks.gli.risk = 'green';
                    else this.answersRisks.gli.risk = 'red';
                }
                if(!!this.result.creatinine){
                    this.answersRisks.creatinine.value = this.result.creatinine + ' mg/dL';
                    const minLimit = 
                        this.customer.age < 1 ? 0.3
                        : this.customer.age <= 2 ? 0.2
                        : this.customer.age <= 12 ? 0.3
                        : this.customer.age <= 18 ? 0.5
                        : this.customer.age > 18 && this.customer.gender == 'M' ? 0.7
                        : this.customer.age > 18 && this.customer.gender == 'F' ? 0.5
                        : 0.7
                    const maxLimit = 
                        this.customer.age < 1 ? 1
                        : this.customer.age <= 2 ? 0.4
                        : this.customer.age <= 12 ? 0.7
                        : this.customer.age <= 18 ? 1
                        : this.customer.age > 18 && this.customer.gender == 'M' ? 1.2
                        : this.customer.age > 18 && this.customer.gender == 'F' ? 1
                        : 1.2
                    if(this.result.creatinine < minLimit) this.answersRisks.creatinine.risk = 'red';
                    else if(this.result.creatinine >= minLimit && this.result.creatinine <= maxLimit) this.answersRisks.creatinine.risk = 'green';
                    else if(this.result.creatinine >= maxLimit) this.answersRisks.creatinine.risk = 'red';
                    else this.answersRisks.creatinine.risk = 'red';
                }
                
                if(!!this.result.tfg){
                    this.answersRisks.tfg.value = this.result.tfg.toFixed(2) + ' mL/min x 1,73m²';

                    if (this.result.tfg >= 60) this.answersRisks.tfg.risk = "green";
                    else if (this.result.tfg > 30 && this.result.tfg <= 59) this.answersRisks.tfg.risk = "yellow";
                    else if (this.result.tfg <= 29) this.answersRisks.tfg.risk = "red";
                }
                if(this.answerSearch("Você fuma?")){
                    this.answersRisks.smoke.value = this.answerSearch("Você fuma?");
                    this.answersRisks.smoke.risk = this.answerSearch("Você fuma?") == 'Sim' ? 'red' : 'green';
                }
                if(this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?")){
                    this.answersRisks.drink.value = this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?");
                    if(this.answersRisks.drink.value == 'Sete ou mais doses por semana') this.answersRisks.drink.risk  = 'red';
                    else if(this.answersRisks.drink.value == 'Três a seis doses por semana') this.answersRisks.drink.risk  = 'yellow';
                    else this.answersRisks.drink.risk  = 'green';
                }
                if(this.answerSearch("Você é portador de Diabetes?")){
                    this.answersRisks.diabetes.value = this.answerSearch("Você é portador de Diabetes?");
                    this.answersRisks.diabetes.risk = this.answerSearch("Você é portador de Diabetes?") == 'Sim' ? 'red' : 'green';
                }
                if(this.answerSearch("Você é portador de alguma doença do coração?")){
                    this.answersRisks.heartDisease.value = this.answerSearch("Você é portador de alguma doença do coração?");
                    this.answersRisks.heartDisease.risk = this.answerSearch("Você é portador de alguma doença do coração?") == 'Sim' ? 'red' : 'green';
                }
                if(this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)")) {
                    this.answersRisks.selfHealth.value = this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)");
                    if(this.answersRisks.selfHealth.value == 'Excelente') this.answersRisks.selfHealth.risk = 'green';
                    else if(this.answersRisks.selfHealth.risk = ['Boa', 'Regular'].includes(this.answersRisks.selfHealth.value)) this.answersRisks.selfHealth.risk = 'yellow';
                    else this.answersRisks.selfHealth.risk = 'red';
                }
                if(this.answerSearch("Esteve internado no último ano?")) {
                    this.answersRisks.hospitalized.value = this.answerSearch("Esteve internado no último ano?");
                    this.answersRisks.hospitalized.risk = this.answerSearch("Esteve internado no último ano?") == 'Não, nenhuma vez' ? 'green' : 'red';
                }
                if(this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?")) {
                    this.answersRisks.medic.value = this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?");
                    this.answersRisks.medic.risk = this.answerSearch("Quantas vezes você procurou atendimento médico ou clínica para tratamento no último ano?") == 'Mais do que seis vezes' ? 'red' : 'green';
                }
                if(this.answerSearch("Selecione abaixo as situações que se encaixam na sua rotina")) {
                    this.answersRisks.caretaker.value = this.fieldAnswerSearch(
                        "Selecione abaixo as situações que se encaixam na sua rotina",
                        "Caso necessário, não possuo alguém da minha confiança para tomar conta de mim"
                    );
                    this.answersRisks.caretaker.risk = this.answersRisks.caretaker.value == 'Sim' ? 'red' : 'green';
                    this.answersRisks.limitedActivity.value = this.fieldAnswerSearch(
                        "Selecione abaixo as situações que se encaixam na sua rotina",
                        "Possuo problemas de saúde que limitam a realização de atividades que dependam de esforços físicos"
                    );
                    this.answersRisks.limitedActivity.risk = this.answersRisks.limitedActivity.value == 'Sim' ? 'red' : 'green';
                    this.answersRisks.dailyActivity.value = this.fieldAnswerSearch(
                        "Selecione abaixo as situações que se encaixam na sua rotina",
                        "Necessito de ajuda para realizar as atividades diárias como banho, vestir, comer e/ou andar"
                    );
                    this.answersRisks.dailyActivity.risk = this.answersRisks.dailyActivity.value == 'Sim' ? 'red' : 'green';
                    this.answersRisks.home.value = this.fieldAnswerSearch(
                        "Selecione abaixo as situações que se encaixam na sua rotina",
                        "Possuo problema de saúde que me faz ficar em casa"
                    );
                    this.answersRisks.home.risk = this.answersRisks.home.value == 'Sim' ? 'red' : 'green';
                    this.answersRisks.walkSupport.value = this.fieldAnswerSearch(
                        "Selecione abaixo as situações que se encaixam na sua rotina",
                        "Uso meios auxiliares de locomoção (andador, bengala ou cadeira de rodas)"
                    );
                    this.answersRisks.walkSupport.risk = this.answersRisks.walkSupport.value == 'Sim' ? 'red' : 'green';
                }
                if(this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?")) {
                    this.answersRisks.activity.value = this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?");
                    if(this.answersRisks.activity.value == 'Nenhuma vez por semana') this.answersRisks.activity.risk = 'red';
                    else if(this.answersRisks.activity.value == 'Menos de três vezes por semana') this.answersRisks.activity.risk = 'yellow';
                    else this.answersRisks.activity.risk = 'green';
                }
                if(this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires).")) {
                    this.answersRisks.fruits.value = this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires).");
                    if(this.answersRisks.fruits.value == 'Nenhuma porção') this.answersRisks.fruits.risk = 'red';
                    else if(this.answersRisks.fruits.value == 'Uma porção') this.answersRisks.fruits.risk = 'yellow';
                    else this.answersRisks.fruits.risk = 'green';
                }
                if(this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?")) {
                    this.answersRisks.animal.value = this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?");
                    if(this.answersRisks.animal.value == 'Quase sempre') this.answersRisks.animal.risk = 'red';
                    else if(this.answersRisks.animal.value == 'Moderadamente') this.answersRisks.animal.risk = 'yellow';
                    else this.answersRisks.animal.risk = 'green';
                }
                if(this.answerSearch("Você é portador de quais doenças ou condições abaixo?")) {
                    this.answersRisks.diseases.value = this.answerSearch("Você é portador de quais doenças ou condições abaixo?");
                    this.answersRisks.diseases.risk = this.answersRisks.diseases.value.length > 0 ? 'red' : 'green';
                }
                if(this.answerSearch("Quantas horas você dorme por dia aproximadamente?")) {
                    this.answersRisks.sleep.value = this.answerSearch("Quantas horas você dorme por dia aproximadamente?");
                    this.answersRisks.sleep.risk = this.answersRisks.sleep.value == 'Menos que 6 horas' ? 'red' : 'green';
                }
                if(this.answerSearch("Você está grávida?")) {
                    this.answersRisks.pregnant.value = this.answerSearch("Você está grávida?");
                    this.answersRisks.pregnant.risk = this.answersRisks.pregnant.value == 'Sim' ? 'red' : 'green';
                }
            },
            loadIcons() {
                let pressureHighVal = this.user.pressure_high.split('-')[0].replace('>', '').replace('<', '').replace('=', '');
                let pressureLowVal = this.user.pressure_low.split('-')[0].replace('>', '').replace('<', '').replace('=', '');
                let circunferenceRisk = 
                    this.user.gender == 'Masculino' && this.user.circunference > 102 ? 'red' :
                    this.user.gender == 'Feminino' && this.user.circunference > 88 ? 'red' : 'green';
                let cronica = !!this.answers.find(an => 
                    an.field.title == 'Possui histórico familiar de doença crônica?' && 
                    an.option.value == 'sim-historico-familiar-de-doenca-do-coracao')
                let cronicaDiab = !!this.answers.find(an => 
                    an.field.title == 'Possui histórico familiar de doença crônica?' && 
                    an.option.value == 'sim-historico-familiar-de-diabetes')
                let cronicaHip = !!this.answers.find(an => 
                    an.field.title == 'Possui histórico familiar de doença crônica?' && 
                    an.option.value == 'sim-historico-familiar-de-hipertensao')
                let cronicaRenal = !!this.answers.find(an => 
                    an.field.title == 'Possui histórico familiar de doença crônica?' && 
                    an.option.value == 'sim-historico-familiar-de-doenca-renal-cronica')
                let hipert = this.answers.find(an => an.field.title == 'Você é portador de Hipertensão?')
                let hipertMed = this.answers.find(an => an.field.title == 'Você toma remédios para Hipertensão?')
                switch (this.risk.altTitle) {
                    case 'cardiovascular':
                        if(
                            !!this.answerSearch(
                            "Você é portador de quais doenças ou condições abaixo?",
                            true,
                            [
                                "Arterosclerose",
                                "Infarto",
                            ]
                        )) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                        if(this.user.gender == 'Masculino') 
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 55 ? 'red' :
                                this.customer.age >= 45 ? 'yellow' : 'green'
                            );
                        else
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 50 ? 'red' :
                                this.customer.age >= 45 ? 'yellow' : 'green'
                            );
                        if(!!this.answersRisks.hdl.value && this.user.gender == 'Masculino')
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                            this.result.hdl >= 45 ? 'green' :
                            this.result.hdl >= 35 ? 'yellow' : 'red');
                        else if(!!this.answersRisks.hdl.value && this.user.gender == 'Feminino')
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                            this.result.hdl >= 50 ? 'green' :
                            this.result.hdl >= 35 ? 'yellow' : 'red');
                        if(this.user.gender == 'Masculino')
                            this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                                this.answersRisks.diabetes.value == 'Não' ? 'green' : 'yellow');
                        else
                            this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                                this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                        this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', 
                            pressureHighVal >= 160 ? 'red' :    
                            pressureHighVal >= 130 ? 'yellow' : 'green');
                        this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', 
                            pressureLowVal >= 100 ? 'red' :
                            pressureLowVal >= 85 ? 'yellow' : 'green');
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                        if(!!this.answersRisks.ldl.value && this.user.gender == 'Masculino')
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                            this.result.ldl >= 190 ? 'red' :
                            this.result.ldl >= 130 ? 'yellow' : 'green');
                        else if(!!this.answersRisks.ldl.value && this.user.gender == 'Feminino')
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                            this.result.ldl >= 160 ? 'red' :
                            this.result.ldl >= 130 ? 'yellow' : 'green');
                        break;
                    case 'internacao':
                        this.addIcon('Auto percepção da saúde', this.answersRisks.selfHealth.value, 'health', this.answersRisks.selfHealth.risk);
                        if(this.user.gender == 'Masculino') 
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 80 ? 'red' :
                                this.customer.age >= 75 ? 'yellow' : 'green'
                            );
                        else
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 80 ? 'red' :
                                this.customer.age >= 75 ? 'yellow' : 'green'
                            );
                        this.addIcon('Internação no último ano', this.answersRisks.hospitalized.value, 'hospitalized', this.answersRisks.hospitalized.risk);  
                        this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', this.answersRisks.heartDisease.risk);
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.risk);
                        this.addIcon('Atendimento médico ou clinica no último ano', this.answersRisks.medic.value, 'medic', this.answersRisks.medic.risk);
                        this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'red' : 'green');
                        if(this.answersRisks.caretaker.risk == 'red')    
                            this.addIcon('Cuidador informal', this.answersRisks.caretaker.value, 'caretaker', this.answersRisks.caretaker.risk);
                        if(this.answersRisks.limitedActivity.risk == 'red')    
                            this.addIcon('Atividade limitada', this.answersRisks.limitedActivity.value, 'limited_activity', this.answersRisks.limitedActivity.risk);
                        if(this.answersRisks.dailyActivity.risk == 'red')    
                            this.addIcon('Ajuda para atividades diárias', this.answersRisks.dailyActivity.value, 'daily_activity', this.answersRisks.dailyActivity.risk);
                        if(this.answersRisks.home.risk == 'red')    
                            this.addIcon('Problema de saúde que faz ficar em casa', this.answersRisks.home.value, 'home', this.answersRisks.home.risk);
                        if(this.answersRisks.walkSupport.risk == 'red')    
                            this.addIcon('Usa meios auxiliares', this.answersRisks.walkSupport.value, 'walk_support', this.answersRisks.walkSupport.risk);
                        break;
                    case 'fragilidade':
                        this.addIcon('Cuidador informal', this.answersRisks.caretaker.value, 'caretaker', this.answersRisks.caretaker.risk);
                        this.addIcon('Atividade limitada', this.answersRisks.limitedActivity.value, 'limited_activity', this.answersRisks.limitedActivity.risk);
                        this.addIcon('Ajuda para atividades diárias', this.answersRisks.dailyActivity.value, 'daily_activity', this.answersRisks.dailyActivity.risk);
                        this.addIcon('Problema de saúde que faz ficar em casa', this.answersRisks.home.value, 'home', this.answersRisks.home.risk);
                        this.addIcon('Usa meios auxiliares', this.answersRisks.walkSupport.value, 'walk_support', this.answersRisks.walkSupport.risk);
                        break;
                    case 'avc':
                        this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'green' : 'yellow');
                        this.addIcon('Idade', this.customer.age, 'age', 
                            this.customer.age >= 75 ? 'red' :
                            this.customer.age >= 50 ? 'yellow' : 'green');
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', 
                            this.answersRisks.imc.realValue >= 35 ? 'red' :
                            this.answersRisks.imc.realValue >= 30 ? 'yellow' : 'green');
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', 
                            this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', 
                            this.answersRisks.smoke.value == 'Não' ? 'green' : 'yellow');
                        if(cronica)
                            this.addIcon('Histórico Familiar Doença Crônica', 'Doença do Coração', 'family', 'yellow');
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                            this.answersRisks.diabetes.value == 'Não' ? 'green' :
                            this.answersRisks.diabetes.value == 'Sim, controlada' ? 'yellow' : 'yellow');
                        if(!!hipertMed)
                            this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', hipertMed.option.label == 'Sim' ? 'red' : 'yellow');
                        else if(!!hipert)
                            this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                        this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', 
                            pressureHighVal >= 140 ? 'red' :
                            pressureHighVal >= 130 ? 'yellow' : 'green');
                        this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', 
                            this.answersRisks.heartDisease.value == 'Sim' ? 'yellow' : 'green');
                        if(!!this.answersRisks.hdl.value)
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                                this.result.hdl < 35 ? 'yellow' : 'green');
                        if(!!this.answersRisks.ldl.value && this.user.gender == 'Masculino' && this.result.ldl >= 130)
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                                this.result.ldl >= 190 ? 'red' :
                                this.result.ldl >= 130 ? 'yellow' : 'green');
                        else if(!!this.answersRisks.ldl.value && this.user.gender == 'Feminino')
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                                this.result.ldl >= 190 ? 'red' :
                                this.result.ldl >= 130 ? 'yellow' : 'green');
                        this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                            this.result.hba1c >= 5.7 ? 'red' : 'green');
                        break;
                    case 'coracao':
                        if(
                            !!this.answerSearch(
                            "Você é portador de quais doenças ou condições abaixo?",
                            true,
                            [
                                "Arterosclerose",
                                "Infarto",
                            ]
                        )) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                        if(this.user.gender == 'Masculino') 
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 55 ? 'red' :
                                this.customer.age >= 45 ? 'yellow' : 'green'
                            );
                        else
                            this.addIcon('Idade', this.customer.age, 'age', this.customer.age >= 50 ? 'red' :
                                this.customer.age >= 45 ? 'yellow' : 'green'
                            );
                        if(!!this.answersRisks.hdl.value && this.user.gender == 'Masculino')
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                            this.result.hdl >= 45 ? 'green' :
                            this.result.hdl >= 35 ? 'yellow' : 'red');
                        else if(!!this.answersRisks.hdl.value && this.user.gender == 'Feminino')
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                            this.result.hdl >= 50 ? 'green' :
                            this.result.hdl >= 35 ? 'yellow' : 'red');
                        if(this.user.gender == 'Masculino')
                            this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                                this.answersRisks.diabetes.value == 'Não' ? 'green' : 'yellow');
                        else
                            this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                                this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                        this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', 
                            pressureHighVal >= 160 ? 'red' :    
                            pressureHighVal >= 130 ? 'yellow' : 'green');
                        this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', 
                            pressureLowVal >= 100 ? 'red' :
                            pressureLowVal >= 85 ? 'yellow' : 'green');
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                        if(!!this.answersRisks.ldl.value && this.user.gender == 'Masculino')
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                            this.result.ldl >= 190 ? 'red' :
                            this.result.ldl >= 130 ? 'yellow' : 'green');
                        else if(!!this.answersRisks.ldl.value && this.user.gender == 'Feminino')
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                            this.result.ldl >= 160 ? 'red' :
                            this.result.ldl >= 130 ? 'yellow' : 'green');
                        break;
                    case 'dislipidemia':
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', 
                            this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                        this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', 
                            this.answersRisks.animal.value == 'Quase sempre' ? 'yellow' : 'green');
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                            this.answersRisks.diabetes.value == 'Não' ? 'green' : 'green');
                        if(!!this.answersRisks.hdl.value)
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', 
                                this.result.hdl < 35 ? 'red' : 'green');
                        if(!!this.answersRisks.ldl.value)
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'ldl', 
                                this.result.ldl >= 130 ? 'red' : 'green');
                        if(!!this.answersRisks.tri.value)
                            this.addIcon('Triglicerídeos', this.answersRisks.tri.value, 'tri', this.result.triglicerideos >= 150 ? 'red' : 'green');
                        if(!!this.answersRisks.hba1c.value)
                            this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                                this.result.hba1c >= 5.7 ? 'red' : 'green' );
                        break;
                    case 'metabolica':
                        this.addIcon('Circunferência abdominal', this.user.circunference, 'circunference', circunferenceRisk);
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', this.answersRisks.diabetes.risk);
                        this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', 
                            pressureHighVal >= 140 ? 'red' :
                            pressureHighVal >= 130 ? 'yellow' : 'green');
                        this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', 
                            pressureLowVal >= 90 ? 'red' :
                            pressureLowVal >= 85 ? 'yellow' : 'green');
                        if(!!this.answersRisks.hdl.value)
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.answersRisks.hdl.risk);
                        if(!!this.answersRisks.ldl.value)
                            this.addIcon('Triglicerídeos', this.answersRisks.tri.value, 'tri', this.answersRisks.tri.risk);
                        if(!!this.answersRisks.hba1c.value)
                            this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                                this.result.hba1c >= 5.7 ? 'red' : 'green' );
                        break;
                    case 'muscular':
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                        this.addIcon('Auto percepção da saúde', this.answersRisks.selfHealth.value, 'health', this.answersRisks.selfHealth.risk);
                        this.addIcon('Horas de sono', this.answersRisks.sleep.value, 'sleep', this.answersRisks.sleep.risk);
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.risk);
                        this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', this.answersRisks.fruits.risk);
                        this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.risk);
                        this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', this.answersRisks.drink.risk);
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                        if(
                            !!this.answerSearch(
                            "Você é portador de quais doenças ou condições abaixo?",
                            true,
                            [
                                "Lesões no fêmur ou joelho",
                                "Hérnia de disco ou transtornos de discos intervertebrais",
                                "Lesões no ombro",
                                "Lesões no tornozelo e pé",
                                "Tendinites",
                                "Artrites",
                                "Lesões no punho e mão"
                            ]
                        )) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                        break;
                    case 'hipertensao':
                        this.addIcon('Pressão (Sistólica)', this.user.pressure_high, 'pressure', 
                            pressureHighVal >= 160 ? 'red' :
                            pressureHighVal >= 130 ? 'yellow' : 'green');
                        this.addIcon('Pressão (Diastólica)', this.user.pressure_low, 'pressure', 
                            pressureLowVal >= 90 ? 'red' :
                            pressureLowVal >= 85 ? 'yellow' : 'green');
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', 
                            this.answersRisks.imc.realValue >= 25 ? 'red' :
                            this.answersRisks.imc.realValue >= 18.5 ? 'green' : 'yellow', true);
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', 
                            this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'red' : 
                            this.answersRisks.activity.value == 'Menos de três vezes por semana' ? 'yellow' : 'green', true);
                        this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', 
                            this.answersRisks.fruits.value == 'Nenhuma porção' ? 'red' :
                            this.answersRisks.fruits.value == 'Uma porção' ? 'yellow' : 'green', true);
                        this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', 
                            this.answersRisks.animal.value == 'Quase sempre' ? 'red' :
                            this.answersRisks.animal.value == 'Moderadamente' ? 'yellow' : 'green', true);
                        this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', 
                            this.answersRisks.drink.value == 'Sete ou mais doses por semana' ? 'red' :
                            this.answersRisks.drink.value == 'Três a seis doses por semana' ? 'yellow' : 'green', true);
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', 
                            this.answersRisks.smoke.value == 'Sim' ? 'red' :
                            this.answersRisks.smoke.value == 'Parei há um ano' ? 'yellow' : 'green', true);
                        if(cronicaHip)
                            this.addIcon('Histórico Familiar Doença Crônica', 'Hipertensão', 'family', 'red', true);
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                            this.answersRisks.diabetes.value == 'Não' ? 'green' :
                            this.answersRisks.diabetes.value == 'Sim, controlada' ? 'yellow' : 'red', true);
                        if(!!this.answersRisks.hdl.value)
                            this.addIcon('Colesterol HDL', this.answersRisks.hdl.value, 'hdl', this.answersRisks.hdl.risk, true);
                        if(!!this.answersRisks.ldl.value)
                            this.addIcon('Colesterol LDL', this.answersRisks.ldl.value, 'hdl', this.answersRisks.ldl.risk, true);
                        if(!!this.answersRisks.hba1c.value)
                            this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                                this.result.hba1c >= 5.7 ? 'red' : 'green', true);
                        break;
                    case 'diabetes':
                        this.addIcon('Sexo biológico', this.user.gender, 'gender', this.user.gender == 'Masculino' ? 'yellow' : 'green');
                        this.addIcon('Idade', this.customer.age, 'age', 
                            this.customer.age >= 50 ? 'red' : 
                            this.customer.age >= 40 ? 'yellow' : 'green');
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', 
                            this.answersRisks.imc.realValue >= 35 ? 'red' :
                            this.answersRisks.imc.realValue >= 30 ? 'yellow' : 'green');
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', 
                            this.answersRisks.activity.value == 'Nenhuma vez por semana' ? 'yellow' : 'green');
                        if(cronicaDiab)
                            this.addIcon('Histórico Familiar Doença Crônica', 'Diabetes', 'family', 'yellow');
                        if(!!hipertMed)
                            this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', 'yellow');
                        else if(!!hipert)
                            this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                        this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                            this.result.hba1c >= 5.7 ? 'red' : 'green');
                        break;
                    case 'osteoporose':
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                        this.addIcon('Atividade física', this.answersRisks.activity.value, 'activity', this.answersRisks.activity.risk);
                        this.addIcon('Consumo de frutas e verduras', this.answersRisks.fruits.value, 'fruits', this.answersRisks.fruits.risk);
                        this.addIcon('Consumo de gordura animal', this.answersRisks.animal.value, 'animal', this.answersRisks.animal.risk);
                        this.addIcon('Bebida alcoolica', this.answersRisks.drink.value, 'drink', this.answersRisks.drink.risk);
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                        if(
                            this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas'
                        ) this.addIcon('Doenças autorreferidas', this.answersRisks.diseases.value, 'diseases', this.answersRisks.diseases.value);
                        break;
                    case 'renal':
                        this.addIcon('IMC', this.answersRisks.imc.value, 'imc', this.answersRisks.imc.risk);
                        this.addIcon('Creatinina', this.answersRisks.creatinine.value, 'creatinina', this.answersRisks.creatinine.risk);
                        this.addIcon('Filtração Glomerular Estimada', this.answersRisks.tfg.value, 'tfg', this.answersRisks.tfg.risk);
                        this.addIcon('Hemoglobina Glicada (HbA1c)', this.answersRisks.hba1c.value, 'hemoglobin', 
                            this.result.hba1c >= 5.7 ? 'red' : 'green');
                        this.addIcon('Fumante', this.answersRisks.smoke.value, 'smoke', this.answersRisks.smoke.risk);
                        if(cronicaRenal)
                            this.addIcon('Histórico Familiar Doença Crônica', 'Renal', 'family', 'yellow');
                        this.addIcon('Doença do Coração', this.answersRisks.heartDisease.value, 'heart_disease', 
                            this.answersRisks.heartDisease.value == 'Sim' ? 'yellow' : 'green');
                        this.addIcon('Diabético', this.answersRisks.diabetes.value, 'diabetes', 
                                this.answersRisks.diabetes.value == 'Não' ? 'green' : 'red');
                        if(!!hipertMed)
                            this.addIcon('Remédio para Hipertensão', hipertMed.option.label, 'hypertension', hipertMed.option.label == 'Sim' ? 'red' : 'yellow');
                        else if(!!hipert)
                            this.addIcon('Hipertensão', hipert.option.label, 'hypertension', 'green');
                        break;
                    default:
                        break;
                }
            },
            addIcon(title, answer, icon, risk, isSec = false) {
                if(!isSec)
                    this.icons.push({
                        title: title,
                        answer: answer,
                        icon: icon,
                        risk: risk
                    });
                else
                    this.iconsSec.push({
                        title: title,
                        answer: answer,
                        icon: icon,
                        risk: risk
                    });
            },
            getIcon(icon, color) {
                let iconColor = '';
                switch (color) {
                    case 'red':
                        iconColor = 'r'
                        break;
                    case 'yellow':
                        iconColor = 'y'
                        break;
                    case 'green':
                        iconColor = 'g'
                        break;
                    default:
                        iconColor = 'g'
                        break;
                }
                return `${icon}_${iconColor}`;
            },
            getRiskColor(risk){
                switch (risk) {
                    case 'Baixo':
                    case 'Médio baixo':
                    case 'Não detectado':
                        return 'green';
                    case 'Médio':
                    case 'Médio alto':
                        return 'yellow';
                    case 'Alto':
                    case 'Detectado':
                        return 'red';
                    default:
                        return ''
                }
            },
            answerSearch(field, multiple = false, answers = []) {
                let ans = null;
                if (multiple) {
                    if (answers.length > 0) {
                        ans = this.answers.filter(a => {
                            return a.field.title == field && answers.includes(a.option.value);
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans.join(', ');
                    } else {
                        ans = this.answers.filter(a => {
                            return a.field.title == field;
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans;
                    }
                } else {
                    this.answers.map(answer => {
                        if (answer.field.title == field && !multiple)
                            ans = answer.response !== null ? answer.response : answer.option.label;
                    });
                }
                return ans;
            },
            fieldAnswerSearch(field, option) {
                let ans = 'Não'
                this.answers.map(answer => {
                    if(answer.field.title == field && answer.option.label == option) {
                        ans = 'Sim';
                    }
                });
                return ans;
            }
        },
        mounted() {
            console.log('results', this.result)
            this.loadRisks();
            this.loadUser();
            this.loadIcons();
        }
    }
</script>

<style>
    @import "./kit-risks-details.scss";
    @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/KitRisksDetails/KitRisksDetails.vue